// index.jsx — entry del bundle "shell" (R1 "modalità ombra", design §1/§5).
//
// Ordine di boot (defer, PRIMA di workspace-host nel manifest — B2.2):
//  1. window.Workspaces (v2) + window.ShellBus si definiscono SUBITO, pre-React:
//     la guardia di workspace-host.js:13 (`if (window.Workspaces) return`) si spegne
//     da sola e il vecchio host resta nel manifest come KILL-SWITCH vivo (B2.4r:
//     bundle shell 404/rimosso → wsh riprende identico).
//  2. host.boot(): CSS wsh verbatim, boot-veil, restore workspace, hook rail.
//  3. waitForAuth() → mount del frame React (in R1: solo MobileBar). Il frame non
//     monta MAI senza crm_token (B2.14); al logout si smonta.

import React from 'react';
import ReactDOM from 'react-dom';
import { createBus, EVENTS } from './bus.js';
import { createRegistry } from './registry.js';
import { createShellHost } from './host.js';
import { createRouteStore, HOST_IDS } from './legacy-bridge.js';
import { createAuthGate } from './auth.js';
import { initialRoute, installHashReflect, takeHistoryOwnership } from './router.js';
import { shellRouterEnabled } from './flags.js';
import { createLoader, createOutlet } from './loader.js';
import { ShellFrame } from './Shell.jsx';

(function () {
  const win = window;

  // Se Workspaces esiste già, il boot lo ha vinto qualcun altro (workspace-host
  // caricato prima? doppio inject?): la shell si fa da parte, MAI due host.
  if (win.Workspaces) {
    console.error('[shell] window.Workspaces esiste già: shell inattiva (host legacy al comando).');
    return;
  }

  const bus = createBus(EVENTS);
  const registry = createRegistry(bus);
  const routeStore = createRouteStore(win, (id) => HOST_IDS.indexOf(id) === -1);
  const host = createShellHost({
    win, registry, bus, routeStore,
    // R2 (§8 tempo 1): route di boot = hash > shell_route > wsh_active legacy
    bootRoute: () => initialRoute(win, routeStore),
    // R7 (§9): moduli ospiti lazy — loader on-demand + outlet loading/errore.
    // Sotto workspace-host (bundle 404) questo file non esegue: i lazy restano
    // irraggiungibili in quel degrado — DICHIARATO al gate, rollback manifest-only.
    loader: createLoader({ win, registry }),
    outlet: createOutlet(win),
  });

  win.ShellBus = bus;
  win.Workspaces = {
    // v1 (semantica wsh preservata per i chiamanti legacy)
    register: (w) => registry.register(w),
    show: (id) => host.activate(id),
    hide: () => host.deactivate(),
    active: () => host.active(),
    // v2 (design §3)
    navigate: (moduleId, itemId, params) => host.navigate(moduleId, itemId, params),
    bus,
    version: 2,
    // R4 (adapter ospiti, design §10/§6.2): gli adapter sono BUNDLE separati e
    // parlano con la shell SOLO da qui (regola B2: niente global di altri moduli).
    //  - has: l'adapter fa l'upgrade SOLO se il modulo v1 si è davvero registrato
    //    (mai una v2 orfana che poi collide con la register del modulo).
    //  - update: patch di una entry esistente — canale del fallback automatico
    //    assertBridge rosso ⇒ submenu:'internal' (mai proxy silenzioso).
    has: (id) => registry.has(id),
    update: (id, patch) => registry.update(id, patch),
  };

  // R4: inoltro dell'evento 'toast' del catalogo (§4) a window.toast del monolite
  // (index.html:3579, kind 'error'|'success'|'info'). Prima di R4 nessuno emetteva
  // 'toast'; ora i bridge/adapter falliscono RUMOROSAMENTE da qui. Senza monolite
  // (pagina rotta): console, mai silenzio.
  bus.on('toast', (p) => {
    const kind = p && p.kind === 'error' ? 'error' : p && p.kind === 'ok' ? 'success' : 'info';
    const msg = (p && p.msg) || '';
    if (typeof win.toast === 'function') win.toast(msg, kind);
    else (kind === 'error' ? console.error : console.log)('[shell] toast (' + kind + '): ' + msg);
  }, { replay: false });

  host.boot();
  // §8, DUE tempi. R5 (flag shell_router, DEFAULT OFF in questa ondata — opt-in
  // localStorage.shell_router='1'): la shell prende la history via hook
  // window._historyReady (mossa 1 QUI, pre-DCL: i defer eseguono prima
  // dell'evento — il gate timing è dentro takeHistoryOwnership). Se la presa in
  // carico è rifiutata (init 3b del monolite già girato) o la flag è spenta:
  // R2, reflect PASSIVO dell'hash — solo replaceState, zero entry nuove, la
  // history resta al monolite. Identico a oggi.
  const historyOwned = shellRouterEnabled(win) && !!takeHistoryOwnership({ win, bus, host });
  if (!historyOwned) installHashReflect({ win, bus, host });
  bus.emit('shell:ready', { modules: registry.list().map((m) => m.id) });
  console.log('[shell] Workspaces v2 pronto — workspace-host dormiente (kill-switch vivo).');

  // ===== AUTH-GATING DEL FRAME (§5) =====
  const gate = createAuthGate(win, bus);
  let reactRoot = null;
  let rootEl = null;

  function mountFrame() {
    if (reactRoot || !doc()) return;
    rootEl = win.document.createElement('div');
    rootEl.id = 'shell-root';
    win.document.body.appendChild(rootEl);
    reactRoot = ReactDOM.createRoot(rootEl);
    reactRoot.render(<ShellFrame host={host} />);
    host.kickEnsureButtons(); // il rail admin nasce col token: aggancia subito i bottoni ospite
  }
  function unmountFrame() {
    if (!reactRoot) return;
    try { reactRoot.unmount(); } catch (e) { /* già smontato */ }
    if (rootEl && rootEl.parentNode) rootEl.parentNode.removeChild(rootEl);
    reactRoot = null; rootEl = null;
  }
  function doc() { return win.document && win.document.body; }

  gate.waitForAuth().then(() => {
    mountFrame();
    // logout / sessione scaduta → frame giù + auth:changed{logged:false} (il login
    // del monolite fa location.reload, ma il gate copre anche il 401 senza reload).
    gate.onChange((logged) => { if (logged) mountFrame(); else unmountFrame(); });
  });
})();
